import Cookies from 'universal-cookie';

import { SessionEventChannel } from '../modules/EventChannel';

export const AUTHENTICATION_TOKEN_KEY = 'developer_portal_oauth_sso_token';

export const REFRESH_TOKEN_KEY = 'developer_portal_refresh_token';

export const GENERATE_ACCESS_TOKEN = 'generate-access-token';

export const SESSION_EVENT_CHANNEL = new SessionEventChannel();

export const COOKIES = new Cookies();

export const SESSION_OBJECT_PREFIX = `session-object::`;

export const AUTH_ERROR_DESCRIPTIONS = {
  ACCOUNT_NOT_FULLY_SET_UP: 'Account is not fully set up',
};

export const USER_SESSION_URL = 'user_session_url';
